module.exports = __webpack_public_path__ + "img/Lulu&Luigi_DG.4d0a6a1c.png";